const RELAY_FUTURE_ADDED_VALUE = "%future added value";
export default RELAY_FUTURE_ADDED_VALUE;
